import { connectionTypes } from "./connection.types";

const INITIAL_STATE = {
  isReconnecting: false,
  isConnected: false,
};

const connectionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //
    case connectionTypes.SET_IS_RECONNECTING:
      return {
        ...state,
        isReconnecting: action.payload,
      };

    case connectionTypes.SET_IS_CONNECTED:
      return {
        ...state,
        isConnected: action.payload,
      };

    default:
      return state;
  }
};

export default connectionReducer;
